import React from 'react';
import { GlossaryText } from './Glossary';
export function Captions({
  text,
  beatKey
}: {
  text: string;
  beatKey: number;
}) {
  return <div className="pointer-events-none absolute inset-x-0 bottom-[96px] z-20 flex justify-center px-6" data-id="element-109" data-mp="cbjn5phjsoos">
      <p key={beatKey} className="pointer-events-auto max-w-[720px] text-center text-[21px] font-medium leading-[30px] tracking-[-0.01em] text-[#EDEEF2] animate-[captionIn_0.5s_ease_both] max-sm:text-[17px] max-sm:leading-[25px]" data-id="element-110" data-mp="3uhesiyc23mlt">
        <GlossaryText text={text} data-id="element-111" data-mp="3pj4soafdzxtv" />
      </p>
    </div>;
}